var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from "@material-ui/core";
import React from "react";
export default React.forwardRef((_a, ref) => {
    var { type = "default", textAlign, noCellBorder, action, isDisabled, isFocusable, minWidth, maxWidth, className = "", width, height } = _a, otherProps = __rest(_a, ["type", "textAlign", "noCellBorder", "action", "isDisabled", "isFocusable", "minWidth", "maxWidth", "className", "width", "height"]);
    const { basic, head } = useStyles({
        textAlign,
        isDisabled,
        noCellBorder,
        isFocusable,
        minWidth,
        maxWidth,
        width,
        height,
    });
    if (type === "default")
        return (React.createElement("td", Object.assign({ ref: ref, className: className + " " + basic }, otherProps, { tabIndex: -1 })));
    else
        return (React.createElement("th", Object.assign({ ref: ref, className: className + " " + head }, otherProps, { tabIndex: !isFocusable ? -1 : undefined })));
});
const useStyles = makeStyles((theme) => ({
    basic: ({ textAlign, isDisabled, maxWidth, noCellBorder, minWidth, width, height, }) => (Object.assign({ padding: 8, verticalAlign: "middle", whiteSpace: "pre-wrap", wordBreak: "break-word", textAlign,
        maxWidth,
        minWidth, minHeight: 40, height,
        width, color: isDisabled ? theme.palette.text.disable : theme.palette.text.primary, outline: "none", transition: !noCellBorder ? theme.transitions.create("box-shadow") : "", backgroundColor: theme.palette.cell.default }, theme.typography.listItemText)),
    head: ({ textAlign = "left", isFocusable, noCellBorder, minWidth, maxWidth, width, }) => {
        const styles = Object.assign({ color: theme.palette.text.tertiary, padding: 8, margin: 0, textAlign,
            minWidth,
            maxWidth,
            width, outline: "none", verticalAlign: "middle", backgroundColor: theme.palette.cell.default, boxShadow: !noCellBorder
                ? `inset 0 -2px 0 0 ${theme.palette.border.menuContainer} !important`
                : "" }, theme.typography.h5);
        if (isFocusable)
            return Object.assign(Object.assign({}, styles), { "&:hover": {
                    backgroundColor: theme.palette.cell.tableHover,
                }, "&:active": {
                    backgroundColor: theme.palette.cell.tableSelected,
                }, "&:focus": {
                    backgroundColor: theme.palette.cell.default,
                    boxShadow: !noCellBorder
                        ? `inset 0 0 0 2px ${theme.palette.border.focus} !important`
                        : "",
                } });
        return styles;
    },
}));
//# sourceMappingURL=FTLTableCell.js.map